import { Section, stateWord, signed, AURORA_BAR } from "./primitives";

const ComponentRow = ({ c }: { c: any }) => {
  const [word, wcolor] = stateWord(c.score);
  const pctW = c.score != null ? Math.max(0, Math.min(c.score, 100)) : 0;
  return (
    <div className="grid sm:grid-cols-[minmax(0,1fr)_auto] gap-x-8 gap-y-2 items-center py-4 border-b border-white/[0.05] last:border-0"
      data-testid={`li-driving-${c.key}`}>
      <div className="min-w-0">
        <div className="flex flex-wrap items-baseline gap-x-3">
          <p className="font-semibold text-white text-[15px]">{c.name}</p>
          <span className="nl-mono text-[9px] uppercase tracking-[0.2em] text-gray-600">{c.weight}% weight</span>
        </div>
        <p className="text-[12.5px] text-gray-500 mt-1">{c.detail}</p>
        <div className="mt-2.5 h-1 rounded-full bg-white/[0.05] overflow-hidden max-w-md">
          <div className="h-full rounded-full transition-[width] duration-700"
            style={{ width: `${pctW}%`, background: AURORA_BAR }} />
        </div>
      </div>
      <div className="flex sm:flex-col items-baseline sm:items-end gap-x-5 gap-y-1">
        <p>
          <span className="nl-sg text-2xl font-bold text-white">{c.score != null ? Math.round(c.score) : "—"}</span>
          <span className="nl-mono text-[10px] font-bold uppercase ml-2" style={{ color: wcolor }}>{word}</span>
        </p>
        <p className="nl-mono text-[11px] text-gray-500">
          <span className="text-[#00E5FF] font-bold">
            {c.contribution != null ? `${c.contribution}` : "—"}
          </span>
          {" "}of {c.weight} pts
        </p>
      </div>
    </div>
  );
};

export const DrivingIndex = ({ components, themes }: { components: any[]; themes: any[] }) => (
  <Section num="02" title="What's Driving the Index" sub="Weighted contributions, not just scores"
    testid="li-driving-section">
    <div>
      {components.map((c) => <ComponentRow key={c.key} c={c} />)}
    </div>
    {themes.length > 0 && (
      <div className="mt-8">
        <p className="nl-mono text-[9px] uppercase tracking-[0.25em] text-gray-500">
          Narrative signals inside Headline Sentiment
        </p>
        <div className="mt-3 flex flex-wrap gap-2">
          {themes.map((t: any) => (
            <span key={t.key} data-testid={`li-theme-${t.key}`}
              className={`nl-mono text-[10.5px] px-2.5 py-1.5 rounded border ${
                t.dir === "up" ? "border-[#34D399]/25 text-[#34D399]" : "border-[#EF4444]/25 text-[#F87171]"}`}>
              {t.dir === "up" ? "↑" : "↓"} {t.label}
              {t.contribution != null && ` · ${signed(t.contribution, 1)} pts`}
            </span>
          ))}
        </div>
        <p className="text-[11px] text-gray-600 mt-2.5 max-w-2xl leading-relaxed">
          Theme contributions are the index points attributable to stories matching each theme inside the
          sentiment component. A story can match multiple themes, so theme figures overlap by design.
        </p>
      </div>
    )}
  </Section>
);
